module.exports = __webpack_public_path__ + "static/fonts/PlayfairDisplayitalic.9030fe95.ttf";